/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketFilter } from '../../models/support-ticket-filter';
import { SupportTicketHomeViewModel } from '../../models/support-ticket-home-view-model';

export interface GetTickets$Params {
      body?: SupportTicketFilter
}

export function GetTickets(http: HttpClient, rootUrl: string, params?: GetTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketHomeViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetTickets.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketHomeViewModel>;
    })
  );
}

GetTickets.PATH = '/api/Tickets/GetTickets';
